<template>
	<div class="login-body">
		<!-- <div class="login-top-bar">
			<div class="login-topbar-header">
				<a class="topbar-header-log" href="/" target="_self">
					<img class="img" src="../assets/logos.png" alt="易企记">
				</a>
				<h2 class="login-topbar-title">{{ APP_NAME }}云财税</h2>
				
				<div class="sub-topic-text hidden-mobile">
					<a class="sub-topic-text" href="/help.html">帮助中心</a>
					<a class="sub-topic-text" href="/about.html">关于我们</a>
					<a class="sub-topic-text" href="/success.html">成功案例</a>
					<a class="sub-topic-text" href="/buy.html">我要购买</a>
					
				</div>
			</div>
			<img @click="showImage(imageStatus)" v-if="imageStatus" class="contact" src="../assets/contactus.jpg" alt="联系我们">
		</div> -->
		<!-- <div class="login-main-content">
			<div class="login-main-text hidden-mobile"></div>
			<div class="root-login">
				<div class="login-title">
					{{ APP_NAME }}
				</div>
				<component :is="viewName" @changeView="changeView"/>
			</div>
		</div> -->
		<!-- <div class="copyright hidden-mobile">
			2025 All Rights Reserved
			Powered by 易企销（石家庄市）软件开发有限责任公司 {{ APP_NAME }} {{ year }}
		</div> -->
		<div style="height: 100vh; display: flex; flex-direction: column;">
			<Row type="flex" style="flex: 1;height: 100%;width: 100%;" :space-x="10">
				<!-- 左侧 Cell 占比 70% -->
				<Cell :flex="'6'" class="hidden-mobile">
					<div class="login-main-background">
						<!-- <div class="sub-topic-text sub-height">
							<a class="sub-topic-text" href="/buy.html">我要购买</a>
							<a class="sub-topic-text" href="/about.html">关于我们</a>
							<a class="sub-topic-text" href="/success.html">成功案例</a>
							<a class="sub-topic-text" href="/help.html">帮助中心</a>
						</div> -->
						<div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
							<div>
								<img src="../assets/AI智能.png" alt="易企记" width="550" height="550">
								<p style="font-size: 40px;font-weight: 999;">轻松做好账，决策更从容！</p>
								<p>智能、易用、便捷、安全</p>
							</div>
						</div>
						<div class="copyright">
							2025 All Rights Reserved
							Powered by 易企销（石家庄市）软件开发有限责任公司 {{ APP_NAME }} {{ year }}
						</div>
					</div>
				</Cell>

				<!-- 右侧 Cell 占比 30% -->
				<Cell :flex="'4'" style="display: flex; justify-content: center; align-items: center;">
					<div style="width: 100%;height: 100%;position: relative;">
						<div class="sub-topic-text sub-height hidden-mobile" style="position: absolute;right: 10px;">
							<a class="sub-topic-text" href="/buy.html">我要购买</a>
							<a class="sub-topic-text" href="/about.html">关于我们</a>
							<a class="sub-topic-text" href="/success.html">成功案例</a>
							<a class="sub-topic-text" href="/help.html">帮助中心</a>
						</div>
						<div class="root-login" style="background-color: #f3f6f8;position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
							<div class="login-title">
								{{ APP_NAME }}
							</div>
							<component :is="viewName" @changeView="changeView"/>
						</div>
					</div>
				</Cell>
			</Row>
		</div>
	</div>

</template>

<script>
	/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
	import LoginForm from "@/views/login/LoginForm.vue";
	import ForgotPassword from "@/views/login/ForgotPassword.vue";
	import Registered from "@/views/login/Registered.vue";
	import PhoneLoginForm from "@/views/login/PhoneLoginForm.vue";

	export default {
		name: "Login",
		components: {LoginForm, ForgotPassword, Registered,PhoneLoginForm},
		data() {
			return {
				imageStatus: false,
			}
		},
		methods: {
			showImage(imageStatus) {
				if (imageStatus === true) {
					this.imageStatus = false
				} else {
					this.imageStatus = true
				}
			}
		}
	}
</script>
<script setup>

	import {ref} from "vue";

	const viewName = ref('LoginForm');

	const changeView = (toView) => {
		viewName.value = toView;
	}

	localStorage.removeItem("currentTab");
</script>

<style scoped lang="less">
	.login-main-background{
		height: 100vh;
		width: 100%;
		background-image: url("../assets/login-bg.d547ed05.png");
		display: flex;
		flex-direction: column;
	}
	.login-body {
		height: 100vh;
		width: 100%;
		// background-image: url("../assets/logo_bg.png");
		position: relative;
	}

	.login-top-bar {
		background-color: #fff;
		height: 80px;
		width: 100%;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
	}

	.login-topbar-header {
		position: relative;
		max-width: 1200px;
		margin: 0 auto;
		padding: 18px 0;
		height: 80px;
	}

	.topbar-header-log {
		display: inline-block;
		margin-right: 10px;
		// width: 110px;
	}

	.img {
		width: 45px;
		height: 45px
	}

	.login-topbar-title {
		display: inline-block;
		padding: 0 10px;
		font-size: 20px;
		border-left: 1px solid #999;
		top: 50%;
		transform: translateY(-50%);
		font-weight: initial;
	}

	.sub-topic-text {
		padding-left: 10px;
		padding-top: 15px;
		float: left;
		line-height: 45px;
		font-size: 14px;
		color: black;
		margin-right: 20px;
		cursor: pointer;
	}

	.contact {
		position: fixed;
		left: 80%;
		z-index: 2000;
		height: 200px;
	}

	.login-main-content {
		min-width: 420px;
		max-width: 1200px;
		min-height: 800px;
		min-height: calc(100vh - 81px - 89px);
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
	}

	.login-main-text {
		box-sizing: border-box;
		width: 700px;
		height: 520px;
		background-image: url("../assets/dashboard.png");
		background-color: #fff;
		box-shadow: 0px 2px 10px 0px rgba(188, 202, 224, 0.25);
		background-size: cover;
	}

	.root-login {
		position: relative;
		width: 420px;
		height: 530px;
		background-color: #fff;
		font-size: 14px;
		border-color: #e4e4e4;
		overflow: hidden;
		box-shadow: 0px 2px 10px 0px rgba(188, 202, 224, 0.25);
		padding: 0 25px 50px 25px;
	}

	.login-title {
		font-size: 32px;
		text-align: center;
		margin: 10px 0;
		font-weight: bold;
	}

	.copyright {
		height: 20px;
		text-align: center;
		font-size: 12px;
		color: #777;
		margin-top: 16px;
	}

	.sub-height{
		height: 80px;
	}

	@media screen and (max-width: 1050px) {
    .hidden-mobile {
      display: none;
    }
  }
</style>